import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'feature',
    'featureEnabled',
    'featurePrice',
    'featurePricePerUnit',
    'featureHistorical',
    'monthlyCharge',
    'unitCount',
  ]

  connect() {
    [
      this.unitCountTarget,
      ...this.featureEnabledTargets,
      ...this.featureHistoricalTargets,
      ...this.featurePricePerUnitTargets,
      ...this.featurePriceTargets,
    ].forEach((element) => {
      element.addEventListener('change', this.#updateMonthlyCharge.bind(this))
    })

    this.unitCountTarget.dispatchEvent(new Event('change'), { bubbles: true })
  }

  #targetSelector(targetName) {
    return `[data-${this.identifier}-target="${targetName}"]`
  }

  #updateMonthlyCharge() {
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
    let totalMonthlyCharge = 0.0

    this.featureEnabledTargets.forEach((featureEnabledInput) => {
      if (featureEnabledInput.checked) {
        const featureContainer = featureEnabledInput.closest(this.#targetSelector('feature'))

        if (featureContainer) {
          const historicalInput = featureContainer.querySelector(this.#targetSelector('featureHistorical'))
          const perUnitInput = featureContainer.querySelector(this.#targetSelector('featurePricePerUnit'))
          const priceInput = featureContainer.querySelector(this.#targetSelector('featurePrice'))

          if (historicalInput && historicalInput.checked) return

          if (perUnitInput.checked) {
            const unitCount = parseInt(this.unitCountTarget.value) || 0
            const pricePerUnit = parseFloat(priceInput.value) || 0.0
            totalMonthlyCharge += unitCount * pricePerUnit
          } else {
            totalMonthlyCharge += parseFloat(priceInput.value)
          }
        }
      }
    })

    this.monthlyChargeTarget.textContent = formatter.format(totalMonthlyCharge)
  }
}
